const en = {
  repostAlreadyOpined: 'You already have an opinion on this event.',
  quoteCycle: "This repost leads back to your own opinion. Remove the quote to save your comment. Your text is still here.",
  quoteInvalid: "This quote cannot be attached. Remove it to save your comment. Your text is still here.",
  repostAction: 'Repost with your opinion', quoteUnavailable: 'This opinion is no longer available.',
  quoteOpen: 'Open {{name}}’s opinion', quoteExpand: 'Expand {{name}}’s opinion',
  quotePreview: 'Quoted opinion', quoteRemove: 'Remove quote',
  quoteLoadError: 'Could not load this quote. Retry or remove it to continue.',
  quoteNotEnabled: 'Reposts are not available yet. Your text and images are still here. Remove the quote to save only your own comment.',
  quoteChainError: 'Could not load the rest of the chain.', quoteLoadMore: 'Show more opinions',
};
const ru = {
  repostAlreadyOpined: 'Вы уже добавили мнение по этому событию.',
  quoteCycle: "В цепочке уже есть ваше мнение. Уберите цитату, чтобы сохранить комментарий. Ваш текст остался в редакторе.",
  quoteInvalid: "Эту цитату нельзя прикрепить. Уберите её, чтобы сохранить комментарий. Ваш текст остался в редакторе.",
  repostAction: 'Репост со своим мнением', quoteUnavailable: 'Это мнение больше недоступно.',
  quoteOpen: 'Открыть мнение: {{name}}', quoteExpand: 'Развернуть мнение: {{name}}',
  quotePreview: 'Цитируемое мнение', quoteRemove: 'Убрать цитату',
  quoteLoadError: 'Не удалось загрузить цитату. Чтобы продолжить, повторите попытку или уберите её.',
  quoteNotEnabled: 'Репосты пока недоступны. Ваш текст и изображения остались в редакторе. Уберите цитату, чтобы сохранить только свой комментарий.',
  quoteChainError: 'Не удалось загрузить продолжение цепочки.', quoteLoadMore: 'Показать следующие мнения',
};
const translations = {
  en, ru,
  es: {
    repostAlreadyOpined: 'Ya has dado tu opinión sobre este acontecimiento.',
    quoteCycle: "Tu opinión ya está en este hilo. Quita la cita para guardar tu comentario. Tu texto sigue en el editor.",
    quoteInvalid: "No se puede adjuntar esta cita. Quítala para guardar tu comentario. Tu texto sigue en el editor.",
    repostAction: 'Republicar con tu opinión', quoteUnavailable: 'Esta opinión ya no está disponible.',
    quoteOpen: 'Abrir la opinión de {{name}}', quoteExpand: 'Ampliar la opinión de {{name}}',
    quotePreview: 'Opinión citada', quoteRemove: 'Quitar cita',
    quoteLoadError: 'No se pudo cargar esta cita. Reinténtalo o quítala para continuar.',
    quoteNotEnabled: 'Las republicaciones aún no están disponibles. Tu texto y tus imágenes siguen en el editor. Quita la cita para guardar solo tu propio comentario.',
    quoteChainError: 'No se pudo cargar el resto del hilo.', quoteLoadMore: 'Mostrar más opiniones',
  },
  fr: {
    repostAlreadyOpined: 'Vous avez déjà donné votre avis sur cet événement.',
    quoteCycle: "Votre avis figure déjà dans ce fil. Retirez la citation pour enregistrer votre commentaire. Votre texte est conservé.",
    quoteInvalid: "Cette citation ne peut pas être ajoutée. Retirez-la pour enregistrer votre commentaire. Votre texte est conservé.",
    repostAction: 'Republier avec votre avis', quoteUnavailable: 'Cet avis n’est plus disponible.',
    quoteOpen: 'Ouvrir l’avis de {{name}}', quoteExpand: 'Développer l’avis de {{name}}',
    quotePreview: 'Avis cité', quoteRemove: 'Retirer la citation',
    quoteLoadError: 'Impossible de charger cette citation. Réessayez ou retirez-la pour continuer.',
    quoteNotEnabled: 'Les republications ne sont pas encore disponibles. Votre texte et vos images sont toujours dans l’éditeur. Retirez la citation pour enregistrer uniquement votre propre commentaire.',
    quoteChainError: 'Impossible de charger la suite du fil.', quoteLoadMore: 'Afficher plus d’avis',
  },
  de: {
    repostAlreadyOpined: 'Du hast deine Meinung zu diesem Ereignis bereits abgegeben.',
    quoteCycle: "Deine Meinung ist bereits in dieser Zitatkette enthalten. Entferne das Zitat, um deinen Kommentar zu speichern. Dein Text bleibt erhalten.",
    quoteInvalid: "Dieses Zitat lässt sich nicht anhängen. Entferne es, um deinen Kommentar zu speichern. Dein Text bleibt erhalten.",
    repostAction: 'Mit eigener Meinung reposten', quoteUnavailable: 'Diese Meinung ist nicht mehr verfügbar.',
    quoteOpen: 'Meinung von {{name}} öffnen', quoteExpand: 'Meinung von {{name}} aufklappen',
    quotePreview: 'Zitierte Meinung', quoteRemove: 'Zitat entfernen',
    quoteLoadError: 'Dieses Zitat konnte nicht geladen werden. Versuche es erneut oder entferne es, um fortzufahren.',
    quoteNotEnabled: 'Reposts sind noch nicht verfügbar. Dein Text und deine Bilder sind weiterhin im Editor. Entferne das Zitat, um nur deinen eigenen Kommentar zu speichern.',
    quoteChainError: 'Der Rest der Zitatkette konnte nicht geladen werden.', quoteLoadMore: 'Weitere Meinungen anzeigen',
  },
  it: {
    repostAlreadyOpined: 'Hai già espresso la tua opinione su questo evento.',
    quoteCycle: "La tua opinione è già presente in questa catena. Rimuovi la citazione per salvare il commento. Il tuo testo è ancora qui.",
    quoteInvalid: "Questa citazione non può essere allegata. Rimuovila per salvare il commento. Il tuo testo è ancora qui.",
    repostAction: 'Ripubblica con la tua opinione', quoteUnavailable: 'Questa opinione non è più disponibile.',
    quoteOpen: 'Apri l’opinione di {{name}}', quoteExpand: 'Espandi l’opinione di {{name}}',
    quotePreview: 'Opinione citata', quoteRemove: 'Rimuovi citazione',
    quoteLoadError: 'Impossibile caricare questa citazione. Riprova o rimuovila per continuare.',
    quoteNotEnabled: 'I repost non sono ancora disponibili. Il tuo testo e le tue immagini sono ancora nell’editor. Rimuovi la citazione per salvare solo il tuo commento.',
    quoteChainError: 'Impossibile caricare le altre opinioni citate.', quoteLoadMore: 'Mostra altre opinioni',
  },
  pt: {
    repostAlreadyOpined: 'Você já deu sua opinião sobre este acontecimento.',
    quoteCycle: "Sua opinião já está nesta sequência. Remova a citação para salvar seu comentário. Seu texto continua no editor.",
    quoteInvalid: "Não é possível anexar esta citação. Remova-a para salvar seu comentário. Seu texto continua no editor.",
    repostAction: 'Republicar com sua opinião', quoteUnavailable: 'Esta opinião não está mais disponível.',
    quoteOpen: 'Abrir a opinião de {{name}}', quoteExpand: 'Expandir a opinião de {{name}}',
    quotePreview: 'Opinião citada', quoteRemove: 'Remover citação',
    quoteLoadError: 'Não foi possível carregar esta citação. Tente novamente ou remova-a para continuar.',
    quoteNotEnabled: 'Os reposts ainda não estão disponíveis. Seu texto e suas imagens continuam no editor. Remova a citação para salvar apenas seu próprio comentário.',
    quoteChainError: 'Não foi possível carregar o restante da sequência.', quoteLoadMore: 'Mostrar mais opiniões',
  },
  tr: {
    repostAlreadyOpined: 'Bu olay hakkında zaten görüş bildirdiniz.',
    quoteCycle: "Görüşünüz bu alıntı zincirinde zaten yer alıyor. Yorumunuzu kaydetmek için alıntıyı kaldırın. Metniniz hâlâ düzenleyicide.",
    quoteInvalid: "Bu alıntı eklenemiyor. Yorumunuzu kaydetmek için alıntıyı kaldırın. Metniniz hâlâ düzenleyicide.",
    repostAction: 'Kendi görüşünle yeniden paylaş', quoteUnavailable: 'Bu görüş artık kullanılamıyor.',
    quoteOpen: '{{name}} adlı kullanıcının görüşünü aç', quoteExpand: '{{name}} adlı kullanıcının görüşünü genişlet',
    quotePreview: 'Alıntılanan görüş', quoteRemove: 'Alıntıyı kaldır',
    quoteLoadError: 'Bu alıntı yüklenemedi. Devam etmek için tekrar deneyin veya alıntıyı kaldırın.',
    quoteNotEnabled: 'Yeniden paylaşma özelliği henüz kullanılamıyor. Metniniz ve görselleriniz hâlâ düzenleyicide. Yalnızca kendi yorumunuzu kaydetmek için alıntıyı kaldırın.',
    quoteChainError: 'Zincirin devamı yüklenemedi.', quoteLoadMore: 'Daha fazla görüş göster',
  },
  ja: {
    repostAlreadyOpined: 'この出来事については、すでに意見を投稿しています。',
    quoteCycle: "引用のつながりに自分の意見が含まれています。コメントを保存するには引用を削除してください。入力した文章は残っています。",
    quoteInvalid: "この引用は追加できません。コメントを保存するには引用を削除してください。入力した文章は残っています。",
    repostAction: '自分の意見を添えてリポスト', quoteUnavailable: 'この意見は現在表示できません。',
    quoteOpen: '{{name}}さんの意見を開く', quoteExpand: '{{name}}さんの意見を展開',
    quotePreview: '引用された意見', quoteRemove: '引用を削除',
    quoteLoadError: 'この引用を読み込めませんでした。再試行するか、引用を削除して続けてください。',
    quoteNotEnabled: 'リポストはまだ利用できません。入力した文章と画像はエディターに残っています。自分のコメントだけを保存するには、引用を削除してください。',
    quoteChainError: '引用された意見の続きを読み込めませんでした。', quoteLoadMore: 'さらに意見を表示',
  },
  ko: {
    repostAlreadyOpined: '이 사건에 대한 의견을 이미 남겼습니다.',
    quoteCycle: "인용된 의견 중에 내 의견이 이미 포함되어 있습니다. 댓글을 저장하려면 인용을 삭제하세요. 작성한 내용은 그대로 남아 있습니다.",
    quoteInvalid: "이 인용을 첨부할 수 없습니다. 댓글을 저장하려면 인용을 삭제하세요. 작성한 내용은 그대로 남아 있습니다.",
    repostAction: '내 의견을 덧붙여 재게시', quoteUnavailable: '이 의견은 더 이상 볼 수 없습니다.',
    quoteOpen: '{{name}}님의 의견 열기', quoteExpand: '{{name}}님의 의견 펼치기',
    quotePreview: '인용한 의견', quoteRemove: '인용 삭제',
    quoteLoadError: '이 인용을 불러오지 못했습니다. 다시 시도하거나 인용을 삭제한 후 계속해 주세요.',
    quoteNotEnabled: '재게시 기능은 아직 사용할 수 없습니다. 작성한 글과 이미지는 편집기에 그대로 남아 있습니다. 인용을 삭제하면 자신의 댓글만 저장할 수 있습니다.',
    quoteChainError: '인용 목록의 나머지를 불러오지 못했습니다.', quoteLoadMore: '의견 더 보기',
  },
  zh: {
    repostAlreadyOpined: '你已经对这一事件发表过观点了。',
    quoteCycle: "引用链中已包含你的观点。请移除引用后保存评论，已输入的文字仍然保留。",
    quoteInvalid: "无法添加这条引用。请移除引用后保存评论，已输入的文字仍然保留。",
    repostAction: '添加自己的观点并转发', quoteUnavailable: '此观点已不可用。',
    quoteOpen: '打开{{name}}的观点', quoteExpand: '展开{{name}}的观点',
    quotePreview: '引用的观点', quoteRemove: '移除引用',
    quoteLoadError: '无法加载此引用。请重试或移除引用后继续。',
    quoteNotEnabled: '转发功能暂未开放。您的文字和图片仍保留在编辑器中。移除引用后，即可只保存您自己的评论。',
    quoteChainError: '无法加载后续引用的观点。', quoteLoadMore: '显示更多观点',
  },
  hi: {
    repostAlreadyOpined: 'आप इस घटना पर अपनी राय पहले ही दे चुके हैं।',
    quoteCycle: "इस क्रम में आपकी राय पहले से शामिल है। टिप्पणी सहेजने के लिए उद्धरण हटाएँ। आपका लिखा हुआ टेक्स्ट सुरक्षित है।",
    quoteInvalid: "यह उद्धरण जोड़ा नहीं जा सकता। टिप्पणी सहेजने के लिए इसे हटाएँ। आपका लिखा हुआ टेक्स्ट सुरक्षित है।",
    repostAction: 'अपनी राय जोड़कर रीपोस्ट करें', quoteUnavailable: 'यह राय अब उपलब्ध नहीं है।',
    quoteOpen: '{{name}} की राय खोलें', quoteExpand: '{{name}} की पूरी राय दिखाएँ',
    quotePreview: 'उद्धृत राय', quoteRemove: 'उद्धरण हटाएँ',
    quoteLoadError: 'यह उद्धरण लोड नहीं हो सका। आगे बढ़ने के लिए फिर कोशिश करें या इसे हटा दें।',
    quoteNotEnabled: 'रीपोस्ट की सुविधा अभी उपलब्ध नहीं है। आपका लिखा हुआ टेक्स्ट और चित्र अभी भी एडिटर में हैं। केवल अपनी टिप्पणी सहेजने के लिए उद्धरण हटा दें।',
    quoteChainError: 'बाकी उद्धृत राय लोड नहीं हो सकीं।', quoteLoadMore: 'और राय दिखाएँ',
  },
};
export default translations;
